import React, { useContext, useState, useEffect, useMemo } from "react";
import {
  Form,
  Select,
  Card,
  Row,
  Col,
  Switch,
  Typography,
  Tooltip,
} from "antd";
import { UserInfoContext } from "../../../../../Context/CommonContext";
import useMasterContext from "../../../../../Context/MasterContext";
import { useGetApi } from "../../../../../utilFunctions/CustomHooks/useGetAPI";
import { BASE_URL } from "utilFunctions/Constants/urlConstants";
import InfoIcon from "Assets/Icons/InfoIcon";
import { useLocation } from "react-router-dom";

const { Text } = Typography;

const TargetBatches = ({
  batchInfo,
  form,
  selectedPost,
  initialBatchOptions = [],
}: any) => {
  const location = useLocation();
  const { state } = location;
  const { myBatches } = state || {};
  const userInfo = useContext<any>(UserInfoContext);
  const { masters } = useMasterContext();
  const PostType = selectedPost?.postType || form.getFieldValue("postType");

  const [stateOptions, setStateOptions] = useState<any[]>([]);
  const [branchOptions, setBranchOptions] = useState<any[]>([]);
  const [batchOptions, setBatchOptions] = useState<any[]>([]);

  const [selectedState, setSelectedState] = useState<any>(null);
  const [selectedBranch, setSelectedBranch] = useState<any>(null);
  const [selectedStream, setSelectedStream] = useState<any>(null);
  const [selectedClass, setSelectedClass] = useState<any>(null);
  const fexRole = userInfo.fexRole;
  const selectedBatches = Form.useWatch("batchIds", form) || [];
  const { makeRequest: fetchBatches, loading: batchesLoading } = useGetApi(
    (data) => {
      console.log("batches data", data);
      if (data && data?.data) {
        const batchData = data?.data.map((batch: any) => ({
          label: batch.batchName,
          value: batch.id,
        }));
        setBatchOptions([...batchData]);
      } else {
        setBatchOptions([]);
      }
    },
    (error) => {
      setBatchOptions([]);
      console.error(error);
    }
  );
  const allBatchOptions = useMemo(() => {
    const options = batchInfo
      ? [batchInfo, ...initialBatchOptions, ...batchOptions]
      : [...initialBatchOptions, ...batchOptions];
    const uniqueOptions = options.reduce((acc: any[], current: any) => {
      if (current && !acc.find((item: any) => item.value === current.value)) {
        acc.push(current);
      }
      return acc;
    }, []);
    return uniqueOptions;
  }, [batchInfo, batchOptions, initialBatchOptions]);

  const regionOptions = useMemo(() => {
    if (!userInfo?.region || !masters?.regions) return [];
    const userAllotedRegiondata = userInfo.region.split(",");
    return masters.regions
      .filter((item: any) => userAllotedRegiondata.includes(String(item.id)))
      .map((item: any) => ({
        id: item.id,
        key: item.id,
        label: item.label,
        value: item.regionCode,
      }));
  }, [userInfo?.region, masters?.regions]);

  const streamOptions = useMemo(() => {
    return userInfo?.userStreams || [];
  }, [userInfo?.userStreams]);

  const classOptions = useMemo(() => {
    return (
      masters?.classes.map((item: any) => ({
        value: item.label,
        label: item.label,
      })) || []
    );
  }, [masters?.classes]);

  useEffect(() => {
    if (selectedStream && selectedBranch && selectedClass) {
      const streamLabel = streamOptions.find(
        (s: any) => s.value == selectedStream
      )?.label;
      const url =
        BASE_URL +
        "batch/search" +
        `?stream=${streamLabel}&branchCode=${selectedBranch}&month=9&year=25&sortBy=testDate&sortDir=ASC&clazz=${selectedClass}`;
      fetchBatches(url);
    } else {
      setBatchOptions([]);
    }
  }, [selectedStream, selectedBranch, selectedClass]);

  const handleRegionChange = (value: any) => {
    const region = masters?.regions.find(
      (item: any) => item.regionCode === value
    );
    if (region && masters?.states) {
      const filteredItems = masters.states.filter(
        (item: any) =>
          region.otherMapping.includes(item.value) &&
          userInfo?.stateIds.includes(item.id)
      );
      setStateOptions(filteredItems);
    } else {
      setStateOptions([]);
    }
    setSelectedState(null);
    form.setFieldValue("state", null);
    setSelectedBranch(null);
    form.setFieldValue("branch", null);
    setBranchOptions([]);
    setBatchOptions([]);
  };

  const handleStateChange = (value: any) => {
    setSelectedState(value);
    const filteredbranches: any = [];
    masters?.userAssignedBranches.forEach((item: any) => {
      if (
        item.otherMapping === value &&
        item.regionCode === form.getFieldValue("region")
      ) {
        filteredbranches.push(item);
      }
    });
    setBranchOptions(filteredbranches);
    setSelectedBranch(null);
    form.setFieldValue("branch", null);
    setBatchOptions([]);
  };
  const commentAllowedWatch = Form.useWatch("commentAllowed", form);
  useEffect(() => {
    if (!commentAllowedWatch) {
      form.setFieldValue("commentVisibility", false);
    }
  }, [commentAllowedWatch]);
  const isShow = true;
  return (
    <>
      {PostType == "POST" && selectedBatches.length > 0 && isShow && (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: "32px",
            marginBottom: "16px",
          }}
        >
          <div
            style={{
              display: "flex",
              gap: "8px",
              alignItems: "center",
            }}
          >
            <Text style={{ display: "flex", alignItems: "center", gap: "4px" }}>
              Comment Allowed
            </Text>
            <Tooltip title="Allow students to comment on the post">
              <InfoIcon />
            </Tooltip>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Form.Item
                name="commentAllowed"
                valuePropName="checked"
                style={{ marginBottom: 0 }}
              >
                <Switch />
              </Form.Item>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              gap: "8px",
            }}
          >
            <Text style={{ display: "flex", alignItems: "center", gap: "4px" }}>
              Comment Visibility
              <Tooltip title="Allow students to see each other comments">
                <InfoIcon />
              </Tooltip>
            </Text>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Form.Item
                name="commentVisibility"
                valuePropName="checked"
                style={{ marginBottom: 0 }}
              >
                <Switch disabled={!commentAllowedWatch} />
              </Form.Item>
            </div>
          </div>
        </div>
      )}
      <>
        {fexRole == "Faculty" ? (
          <Card title="My Batches" className="mb-4">
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item
                  name="myBatchesIds"
                  rules={[
                    { required: true, message: "Please select batches!" },
                  ]}
                >
                  <Select
                    mode="multiple"
                    placeholder="Select batches"
                    options={
                      myBatches?.map((batch: any) => ({
                        label: batch.batchName,
                        value: batch.batchId,
                      })) || []
                    }
                    loading={batchesLoading}
                    showSearch={true}
                    filterOption={(input: any, option: any) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  />
                </Form.Item>
              </Col>
            </Row>
          </Card>
        ) : (
          <Card title="Target Batches">
            <Row gutter={16}>
              <Col xs={12} sm={12} md={6} lg={4} xl={4}>
                <Form.Item name="stream">
                  <Select
                    placeholder="Stream"
                    options={streamOptions}
                    onChange={(value) => setSelectedStream(value)}
                  />
                </Form.Item>
              </Col>
              <Col xs={12} sm={12} md={6} lg={4} xl={4}>
                <Form.Item name="class">
                  <Select
                    placeholder="Class"
                    options={classOptions}
                    onChange={(value) => setSelectedClass(value)}
                  />
                </Form.Item>
              </Col>
              <Col xs={12} sm={12} md={6} lg={4} xl={4}>
                <Form.Item name="region">
                  <Select
                    placeholder="Region"
                    onChange={handleRegionChange}
                    options={regionOptions}
                    allowClear
                  />
                </Form.Item>
              </Col>
              <Col xs={12} sm={12} md={6} lg={4} xl={4}>
                <Form.Item name="state">
                  <Select
                    placeholder="State"
                    onChange={handleStateChange}
                    value={selectedState}
                    options={stateOptions}
                    allowClear
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                <Form.Item name="branch">
                  <Select
                    allowClear
                    mode="multiple"
                    placeholder="Branch"
                    options={branchOptions}
                    onChange={(value) => setSelectedBranch(value)}
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  name="batchIds"
                  rules={[
                    { required: true, message: "Please select batches!" },
                  ]}
                  label="Select batches to publish to..."
                >
                  <Select
                    mode="multiple"
                    placeholder="Select batches"
                    options={allBatchOptions}
                    loading={batchesLoading}
                    showSearch={true}
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  />
                </Form.Item>
              </Col>
            </Row>
          </Card>
        )}
      </>
    </>
  );
};

export default TargetBatches;
